/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { ReactComponent as CloseIcon } from '@material-design-icons/svg/round/close.svg'
import { AnimatePresence, motion } from 'framer-motion'
import IconButton from 'components/common/IconButton'
import c from './GenerationModal.module.scss'

const handleInnerClick = (e: React.MouseEvent<HTMLDivElement>) => {
  e.stopPropagation()
}

interface GenerationModalProps {
  open: boolean
  children: React.ReactNode
  onClose?: () => void
}

function GenerationModal({
  open,
  children,
  onClose = undefined,
}: GenerationModalProps) {
  const modalRef = useRef<HTMLDivElement>(null)

  const classNames = useMemo(() => {
    let result = c.wrapper
    if (open) result += ` ${c.wrapperOpen}`
    return result
  }, [open])

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key !== 'Escape') return
      if (onClose) onClose()
    },
    [onClose],
  )

  useEffect(() => {
    if (open) {
      modalRef?.current!.focus()
    }
  }, [open, onClose])

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          role="button"
          className={classNames}
          // onClick={onClose}
          onKeyDown={handleKeyPress}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className={c.modalContainer}>
            <div
              role="button"
              aria-hidden="true"
              className={c.modal}
              onClick={handleInnerClick}
            >
              <div className={c.content} tabIndex={0} ref={modalRef}>
                <div className={c.head}>
                  {onClose && (
                    <IconButton onClick={onClose}>
                      <CloseIcon style={{ fill: 'currentColor' }} />
                    </IconButton>
                  )}
                </div>
                <div>{children}</div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default GenerationModal
